'use strict';

const scrollElementBelowHeader = require('../utils/fixedHeaderScrollOffset').scrollElementBelowHeader;

/**
 * Toggles the branch availability dropdown open state.
 * @param {jQuery} $wrapper - Branch availability component wrapper.
 * @param {boolean} isOpen - Whether the dropdown should be open.
 */
function setBranchAvailabilityOpen($wrapper, isOpen) {
    const $trigger = $wrapper.find('.branch-availability__trigger').first();
    const $chevron = $wrapper.find('.branch-availability__chevron');

    $wrapper.toggleClass('is-open', isOpen);
    $trigger.attr('aria-expanded', isOpen ? 'true' : 'false');
    $wrapper.find('.branch-availability__panel').prop('hidden', !isOpen);
    $chevron.toggleClass('branch-availability__chevron--open', isOpen);
}

module.exports = {
    showStoreAvailabilityModal: function () {
        $('body').on('click', '.js-btn-check-store-availability', function (event) {
            event.preventDefault();

            const $trigger = $(this);
            const $wrapper = $trigger.closest('.branch-availability');

            if ($wrapper.length) {
                setBranchAvailabilityOpen($wrapper, !$wrapper.hasClass('is-open'));

                return;
            }

            const $availability = $('.js-product-stores.branch-availability');

            if ($availability.length) {
                setBranchAvailabilityOpen($availability, true);
                scrollElementBelowHeader($availability.get(0));

                return;
            }

            $('#check-store-availability-modal').modal('toggle');
        });

        $('body').on('click', function (event) {
            if ($(event.target).closest('.branch-availability').length || $(event.target).closest('.js-btn-check-store-availability').length) return;

            $('.branch-availability.is-open').each(function () {
                setBranchAvailabilityOpen($(this), false);
            });
        });
    }
};
